import {
  BookOpen,
  GraduationCap,
  HandHeart,
  HeartHandshake,
  Lightbulb,
  MessageCircleHeart,
  Route,
  School,
  ShieldCheck,
  Sparkles,
  Users,
} from 'lucide-react';
import { assetPath } from '../utils/assetPath';

export const organization = {
  name: 'Fundación Tony',
  phone: '+52 229 984 2590',
  whatsapp: '522299842590',
  facebook: 'https://www.facebook.com/FundacionTONY',
  instagram: 'https://www.instagram.com/tony.fundacion/',
  scholarships: 'https://becas.fundaciontony.org/',
};

export const programs = [
  {
    id: 'rehabilitacion',
    path: '/programas/rehabilitacion',
    eyebrow: 'Salud y acompañamiento',
    title: 'Rehabilitación contra las adicciones',
    shortTitle: 'Becas de rehabilitación',
    intro:
      'Facilitamos el acceso a tratamiento especializado para personas en situación de vulnerabilidad económica y orientamos a sus familias durante cada etapa del proceso.',
    email: 'trios@fundaciontony.org',
    theme: 'rehab',
    color: '#ef3340',
    secondary: '#ffb55f',
    image: assetPath('/assets/photos/482004702_1040535661453717_1902875297155302169_n.jpg'),
    icon: HeartHandshake,
    metric: '6 becas',
    metricLabel: 'otorgadas de enero a junio de 2026',
    quote: 'Acompañar también es abrir una oportunidad para comenzar de nuevo.',
    storyTitle: 'Un proceso sensible, profesional y acompañado.',
    details: [
      {
        title: 'Informar',
        text: 'Orientamos a familiares sobre CÚSPIDE, el tratamiento y las alternativas disponibles.',
        icon: MessageCircleHeart,
      },
      {
        title: 'Diagnosticar',
        text: 'Una sesión clínica presencial permite establecer una referencia y decidir la canalización adecuada.',
        icon: ShieldCheck,
      },
      {
        title: 'Canalizar',
        text: 'Cuando se cumplen los requisitos, solicitamos a CÚSPIDE el diagnóstico de viabilidad de internamiento.',
        icon: Route,
      },
      {
        title: 'Otorgar la beca',
        text: 'Tras la aceptación del paciente, formalizamos el apoyo para facilitar su tratamiento especializado.',
        icon: HandHeart,
      },
    ],
  },
  {
    id: 'valores',
    path: '/programas/se-tu-amigo',
    eyebrow: 'Prevención y formación',
    title: 'Sé tu amigo, vive con valores',
    shortTitle: 'Sé tu amigo',
    intro:
      'Llevamos a escuelas y comunidades una formación que convierte los valores en herramientas para prevenir riesgos, fortalecer vínculos y tomar mejores decisiones.',
    email: 'gdiaz@fundaciontony.org',
    theme: 'values',
    color: '#79d11c',
    secondary: '#1c3e97',
    image: assetPath('/assets/photos/537123962_1192205412952143_8381438350100508549_n.jpg'),
    icon: Sparkles,
    metric: '45 docentes',
    metricLabel: 'participan en promedio cada año en Escuela de Padres',
    quote: 'Los valores son una brújula para construir comunidad.',
    storyTitle: 'Prevenir también significa aprender a elegir.',
    details: [
      {
        title: 'Formación de instructores',
        text: 'Capacitamos a quienes comparten las pláticas en planteles de Veracruz y Boca del Río.',
        icon: Users,
      },
      {
        title: 'Vinculación universitaria',
        text: 'Colaboramos con la Universidad Autónoma Popular de Veracruz mediante servicio social y prácticas profesionales.',
        icon: School,
      },
      {
        title: 'Pláticas preventivas',
        text: 'Acercamos información sobre prevención de adicciones y formación en valores a escuelas de nivel básico y medio.',
        icon: Lightbulb,
      },
      {
        title: 'Materiales educativos',
        text: 'Creamos recursos de apoyo para que cada sesión sea clara, cercana y útil.',
        icon: BookOpen,
      },
    ],
  },
  {
    id: 'becas',
    path: '/programas/becas-tony-chedraui-mafud',
    eyebrow: 'Educación superior',
    title: 'Becas Tony Chedraui Mafud',
    shortTitle: 'Becas universitarias',
    intro:
      'Impulsamos la permanencia universitaria de jóvenes con excelencia académica y vulnerabilidad socioeconómica mediante apoyos que reconocen su talento y compromiso.',
    email: 'becas1@fundaciontony.org',
    theme: 'scholarship',
    color: '#2941d0',
    secondary: '#f3a51d',
    image: assetPath('/assets/photos/504295535_3056995087797227_3118181787785873911_n.jpg'),
    icon: GraduationCap,
    metric: 'Educación',
    metricLabel: 'como herramienta para transformar vidas y comunidades',
    quote: 'El talento necesita una oportunidad para convertirse en futuro.',
    storyTitle: 'Educación que permanece en la familia y en la comunidad.',
    details: [
      {
        title: 'Continuidad educativa',
        text: 'Los apoyos económicos favorecen la permanencia escolar y ayudan a disminuir la deserción.',
        icon: BookOpen,
      },
      {
        title: 'Excelencia académica',
        text: 'Reconocemos a jóvenes con resultados sobresalientes y compromiso con su formación profesional.',
        icon: Sparkles,
      },
      {
        title: 'Desarrollo integral',
        text: 'Impulsamos liderazgo, movilidad social y una participación positiva en sus comunidades.',
        icon: Users,
      },
      {
        title: 'Legado que transforma',
        text: 'El programa honra la visión humanista del Sr. Antonio Chedraui Mafud.',
        icon: HandHeart,
      },
    ],
  },
];

export const socialFallback = [
  {
    image: assetPath('/assets/photos/503891357_3056995401130529_7834942379768443490_n.jpg'),
    label: 'Comunidad',
    text: 'Cada encuentro fortalece la red de personas que creen en un mejor futuro.',
    url: organization.facebook,
  },
  {
    image: assetPath('/assets/photos/504351234_3056995177797218_5049212354486661804_n.jpg'),
    label: 'Voluntariado',
    text: 'Compartimos conocimiento, tiempo y entusiasmo para multiplicar el impacto.',
    url: organization.instagram,
  },
  {
    image: assetPath('/assets/photos/537687572_1192205376285480_5362959226390351494_n.jpg'),
    label: 'Educación',
    text: 'Acompañamos a nuevas generaciones con herramientas para decidir y crecer.',
    url: organization.facebook,
  },
  {
    image: assetPath('/assets/photos/504225618_3057210251109044_2487410118009274932_n.jpg'),
    label: 'Alianzas',
    text: 'El cambio sostenible se construye sumando capacidades y voluntades.',
    url: organization.instagram,
  },
];
